import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'cm-loading-dialog',
    templateUrl: './cm-loading-dialog.component.html',
    styleUrls: ['./cm-loading-dialog.component.scss'],
    standalone: false
})
export class CmLoadingDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<CmLoadingDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { key: string; defaultValue: string }
	) {}

	get defaultValue(): string {
		return (this.data || {}).defaultValue;
	}

	get key(): string {
		return (this.data || {}).key;
	}
}
